import React from 'react'
import { NavLink } from 'react-router-dom';
import ProjectsAPI from './ProjectsAPI';
const Projects = () => {
    return (
        <>
            <section className="portfolio">
                <div className="container py-3">
                    <h5>These are the websites that I have created before today.</h5>
                    <p>"My Projects showcase my creativity, skills, and achievements, reflecting my passion for excellence and continuous growth."</p>
                    <p>"In these cherished offices, my creativity soars, surrounded by delightful colleagues. A cozy space where dreams bloom, and laughter fills the air, making work an enchanting journey every day".</p>
                    <hr />
                    <marquee scrolldelay="200">"To all the lovely visitors of my website, thank you from the bottom of my heart for being a part of my programming journey and witnessing the projects I've poured my soul into. Your support and presence mean the world to me, and I'm overjoyed that my creations have brought joy and utility to your lives. Your appreciation and encouragement fuel my passion for coding even further. Together, we'll continue to explore new horizons and create amazing things. Sending you all virtual hugs and endless gratitude. Stay curious, stay inspired, and keep spreading the love for technology!" 🤗💕</marquee>
                    <div className="row">
                        {ProjectsAPI.map((data, index) => (
                            <>
                                <div key={index} className="col-lg-3 col-md-6 my-1 d-flex align-items-stretch">
                                    <div className="card">
                                        <img src={data.img} className="img-fluid img-thumbnail" alt={data.alt} />
                                        <div className="card-body">
                                            <h5 className="card-title">{data.title}</h5>
                                            <p>{data.paragraph}</p>
                                            <NavLink to={data.link} target='_rizwan' className="btn-button">Read More</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                        <div className="col box text-white  my-1 d-flex align-items-center">
                            <h5>Right now I am working in a software house, whose name is Website Access and it's a very good company. They have a very good attitude towards their staff. The names of the upcoming companies will also be added here.</h5>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Projects